import React from 'react';
import { Table, TableBody, TableContainer, TableCell, TableRow, TableHead, Typography, Card, CardContent, Container, Stack, Grid, Box, FormControl, TextField } from "@mui/material";
import Paper from '@mui/material/Paper';
import { Tabs, Tab } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AntTabs, AntTab, StyledTableCell, StyledTableRow } from '../tabs_style';
import '../tabs caso 2/tablas.css';  // Asegúrate de tener un archivo CSS para los estilos
import { styled } from '@mui/material/styles';

export default function RebajasROAnterior() {
  const [tabIndex, setTabIndex] = React.useState(5);
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const data = [
    {
      numero: "",
      fechaRebaja: '',
      fechaSolicitud: '',
      mesesRebajar: "",
      sueldo: "",
      rebajaAportacion: "",
      rebajaIntereses: "",
    },
    {
      numero: "",
      fechaRebaja: '',
      fechaSolicitud: '',
      mesesRebajar: "",
      sueldo: "",
      rebajaAportacion: "",
      rebajaIntereses: "",
    },
    {
      numero: "",
      fechaRebaja: '',
      fechaSolicitud: '',
      mesesRebajar: "",
      sueldo: "",
      rebajaAportacion: "",
      rebajaIntereses: "",
    },
    {
      numero: "",
      fechaRebaja: '',
      fechaSolicitud: '',
      mesesRebajar: "",
      sueldo: "",
      rebajaAportacion: "",
      rebajaIntereses: "",
    }
  ];

  return (
    <>
      <Grid container direction="column" alignItems="center">
        <Container>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <h2>Rebajas</h2>
          </div>
        </Container>
        <Container>
          <Box sx={{ position: 'sticky', top: 0, zIndex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Paper square>
              <AntTabs
                value={tabIndex}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{
                  style: { display: 'none' }, // O también puedes usar display: 'none' aquí
              }}
              >
                <AntTab label="Resumen" />
                <AntTab label="Tabla De Interés" />
                <AntTab label="Datos" />
                <AntTab label="Cálculos" />
                <AntTab label="Períodos" />
                <AntTab label="Rebajas" />
                <AntTab label="Comparativa Devolución 10%" />
                <AntTab label="Finiquito y Dictamen" />
              </AntTabs>
            </Paper>
          </Box>

          <Box mt={3}>
            {/* Contenido de la pestaña actual */}
            {tabIndex === 0 && navigate('Separaciones/ResumenROAnterior')}
            {tabIndex === 1 && navigate('Separaciones/TablaDeInteresROAnterior')}
            {tabIndex === 2 && navigate('/Separaciones/ROantes13demayo2014')}
            {tabIndex === 3 && navigate('/Separaciones/CalculosROAnterior')}
            {tabIndex === 4 && navigate('/Separaciones/PeriodosROAnterior')}
            {tabIndex === 5}
            {tabIndex === 6 && navigate('/Separaciones/ComparativaROAnterior')}
            {tabIndex === 7 && navigate('/Separaciones/FiniquitoROAnterior')}
          </Box>
        </Container>
      </Grid>

      <Box marginTop={2} boxShadow={2}>
        <Card variant='outlined'>
          <CardContent>
            <Stack direction="row" marginTop={1}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="nombreparticipante"
                    label="Nombre Del Participante"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="noexpediente"
                    label="No. Expediente"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" marginTop={1}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="cotizante"
                    label="Cotizante"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="noht"
                    label="No. H/T"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" marginTop={1}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="dependencia"
                    label="Dependencia"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
              </Grid>
            </Stack>

          </CardContent>
        </Card>
      </Box>

      <Box marginTop={2} boxShadow={2}>
        <Card variant='outlined'>
          <CardContent>
            <Container>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="h6"><strong>Sección de Registro y Afiliación</strong></Typography>
              </div>
            </Container>
            <Stack direction="row" marginTop={1}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="fechadocrecibido"
                    label="Fecha Doc. Recibido"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="liquidacion"
                    label="Liquidación"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="tipotramite"
                    label="Tipo de Tramite"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
              </Grid>
            </Stack>
          </CardContent>
        </Card>
      </Box>

      <Box marginTop={2} boxShadow={2}>
        <Card variant='outlined'>
          <CardContent>

            <Container>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="h6"><strong>Aportaciones e Intereses</strong></Typography>
              </div>
            </Container>

            <Stack direction="row" marginTop={1}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="aportacionesantes"
                    label="Aportaciones Antes de la Rebaja"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="aportacionesdespues"
                    label="Aportaciones Después de la Rebaja"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" marginTop={1}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="interesesantes"
                    label="Intereses Antes de la Rebaja"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="interesesdespues"
                    label="Intereses Después de la Rebaja"
                    variant="outlined"
                    disabled
                  />
                </FormControl>
              </Grid>
            </Stack>

          </CardContent>
        </Card>
      </Box>

      <Box marginTop={2} boxShadow={2}>
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell style={{ textAlign: 'center' }}><b>Número</b></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><b>Fecha de Rebaja</b></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><b>Fecha de Solicitud</b></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><b>Meses a Rebajar</b></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><b>Sueldo</b></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><b>Rebaja Aportación del 7%</b></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><b>Rebaja Intereses</b></StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <StyledTableRow>
                  <StyledTableCell>{row.numero}</StyledTableCell>
                  <StyledTableCell>{row.fechaRebaja}</StyledTableCell>
                  <StyledTableCell>{row.fechaSolicitud}</StyledTableCell>
                  <StyledTableCell>{row.mesesRebajar}</StyledTableCell>
                  <StyledTableCell>{row.sueldo}</StyledTableCell>
                  <StyledTableCell>{row.rebajaAportacion}</StyledTableCell>
                  <StyledTableCell>{row.rebajaIntereses}</StyledTableCell>
                </StyledTableRow>
              ))}
              {/* Añadir la última fila con el título "TOTAL" */}
              <StyledTableRow>
                <StyledTableCell colSpan={5} style={{ textAlign: 'center' }}><b>TOTAL</b></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>0.00</StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>0.00</StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
}